import styled from "styled-components";

export const ServicesContainer = styled.div`
    min-height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #010606;
    padding: 80px 0;
    overflow: hidden;
`

export const ServicesWrapper = styled.div`
    display: flex;
    gap: 24px;
    padding: 20px 50px;
    overflow-x: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    max-width: 1200px;
    cursor: grab;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    &:active {
        cursor: grabbing;
        scroll-behavior: auto;
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media screen and (max-width: 768px) {
        padding: 20px 20px;
        gap: 16px;
    }
`

export const ServicesCard = styled.div`
    background: linear-gradient(135deg, #1a0533 0%, #4a1c6b 50%, #8b2fc9 100%);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    min-width: 320px;
    max-width: 320px;
    min-height: 380px;
    padding: 30px 25px;
    box-shadow: 0 4px 15px rgba(139, 47, 201, 0.3);
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;
    border: 1px solid rgba(200, 64, 233, 0.2);

    &:hover {
        transform: scale(1.02);
        box-shadow: 0 8px 25px rgba(200, 64, 233, 0.4);
        border-color: rgba(200, 64, 233, 0.5);
    }

    @media screen and (max-width: 768px) {
        min-width: 280px;
        max-width: 280px;
        min-height: 350px;
    }
`

export const ServicesIcon = styled.img`
    height: 140px;
    width: 140px;
    margin-bottom: 25px;
    object-fit: contain;
`

export const ServicesH1 = styled.h1`
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 64px;

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }
`

export const ServicesH2 = styled.h2`
    font-size: 1.2rem;
    margin-bottom: 15px;
    font-weight: 900;
    text-align: center;
    color: #fff;
`

export const ServicesP = styled.p`
    font-size: 0.95rem;
    text-align: center;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.8);
`
